import Component from 'Component';
import DeleteButton from "./ui/DeleteButton";
import Dialog from 'ui/Dialog';
import DropDown from "./ui/DropDown";
import ElementSwitch from "./ui/ElementSwitch";
import MessageRemover from "./ui/MessageRemover";
import MobileScroll from "./ui/MobileScroll";
import NavbarMenu from "./ui/NavbarMenu";
import OnOffButton from "./ui/OnOffButton";
import SVGLoader from "./ui/SVGLoader";
import SalesSwitch from "./ui/SalesSwitch";
import ScrollTo from 'ui/ScrollTo';
import SidebarMenu from "./ui/SidebarMenu";
import SidebarSwitch from "./ui/SidebarSwitch";
import Sort from "./ui/Sort";
import TableScroll from "./ui/TableScroll";
import Tabs from "./ui/Tabs";
import ToolTip from "./ui/ToolTip";
import WindowEvents from 'ui/WindowEvents';
import LogsActivityButton from "./ui/LogsActivityButton";
import SubscriptionActivityButton from "./ui/SubscriptionActivityButton";
import FontSizeScale from "./ui/FontSizeScale";

export default class UI extends Component {

  _namespace = this.constructor.name;

  _components = [
    // Common
    new SVGLoader(this.App, this._namespace),
    new WindowEvents(this.App, this._namespace),
    // Others
    new FontSizeScale(this.App, this._namespace),
    new DeleteButton(this.App, this._namespace),
    new Dialog(this.App, this._namespace),
    new DropDown(this.App, this._namespace),
    new ElementSwitch(this.App, this._namespace),
    new MessageRemover(this.App, this._namespace),
    new MobileScroll(this.App, this._namespace),
    new NavbarMenu(this.App, this._namespace),
    new OnOffButton(this.App, this._namespace),
    new SalesSwitch(this.App, this._namespace),
    new ScrollTo(this.App, this._namespace),
    new SidebarMenu(this.App, this._namespace),
    new SidebarSwitch(this.App, this._namespace),
    new Sort(this.App, this._namespace),
    new TableScroll(this.App, this._namespace),
    new Tabs(this.App, this._namespace),
    new ToolTip(this.App, this._namespace),
    new LogsActivityButton(this.App, this._namespace),
    new SubscriptionActivityButton(this.App, this._namespace),
  ];

  configure() {

    this.components.forEach((component) => {
      let name = component.constructor.name;
      this[name] = component.configure().initialize();
    });

    return super.configure();
  }

  get components() {
    return this._components;
  }

  initialize() {
    return super.initialize();
  }

}